<template>
  <div class="starschermen">
    <subNav
      :subnavstep="subnavstep"
    ></subNav>

    <div class="introtext">
      <h2 class="introtext__title">{{ schermtitel }}</h2>
    </div>

    <div class="questiongroup">
      <button
        v-for="phase in phases"
        :key="phase.term_id"
        @click="onPhaseClicked(phase)"
        class="c-button"
      >
        {{ phase.name }}
      </button>
    </div>
  </div>
</template>

<script>
import subNav from "../components/subNav.vue";
import storage from "../mixins/storage";

const ENDPOINT_NAME = "ppw/v1/doelen";
const axios = require("axios");

export default {
  mixins: [storage],

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      phases: [],
      pushers: [],
      schermtitel: "",
      schermtekst: "",
      initiatief: "",
      fase: "",
      doel: "",
      parent: "",
      subnavstep: "start",
    };
  },

  computed: {},

  components: {
    subNav,
  },

  methods: {
    onPhaseClicked(phase) {
      this.updatePhase(phase.name, this.$route.path);      
      this.$router.push({
        name: "uw-situatie-doel",
        params: {
          doelSlug: phase.slug,
          initiatief: this.initiatief,
          fase: phase.name,
          phase: "",
        },
      });
    },

    getData() {
      const doelSlug = this.$route.params.doelSlug;

      const url = new URL(
        process.env.VUE_APP_REST_URL + ENDPOINT_NAME + "?doelSlug=" + doelSlug
      );

      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios
        .get(url)
        .then((r) => {
          const results = r.data;
          if (!results) {
            this.phases = [];
            this.count = 0;
            this.isEmptyResult = true;
          } else {
            this.schermtitel = r.data.schermtitel;
            this.schermtekst = r.data.schermtekst;
            this.parent = r.data.previous;
            this.phases = r.data.doelen;
            this.count = r.data.count;
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },
  },

  created() {
    setTimeout(() => this.getData(), 50);
    this.resetSituationDetails(2);
  },

  mounted() {
    // Menu 1 active
    document.getElementById("menu_1").classList.add("active");
  },
};
</script>

